export default "__VITE_ASSET__91d558b0__"